import { render, staticRenderFns } from "./SignupForm.vue?vue&type=template&id=50b5f5ac"
import script from "./SignupForm.vue?vue&type=script&lang=js"
export * from "./SignupForm.vue?vue&type=script&lang=js"
import style0 from "./SignupForm.vue?vue&type=style&index=0&id=50b5f5ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports